module.exports = __webpack_public_path__ + "static/chris-494a1e8fd92c653aa0c860c9d4f41fcf.jpg";